module.exports = __webpack_public_path__ + "static/media/ThePowerOfNature.f8b09e8b.vtt";